<div class="modal-header">
    <h4 class="modal-title">{{ heading }}</h4>
    <button
        type="button"
        class="btn btn-circle btn-sm btn-ghost element-cancel"
        [attr.aria-label]="'a11y-close' | translate"
        (click)="modalRef.hide(false)"
    ></button>
</div>
<div class="modal-body">{{ text }}</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.hide(false)">
        {{ 'delete-popup-cancel-button' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="modalRef.hide(true)">
        {{ 'delete-popup-delete-button' | translate }}
    </button>
</div>
